// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"e8a684d4","453":"58f6d107","835":"e4fe261f","863":"6ba9d04a","962":"c7414f32"}[chunkId] + ".chunk.js";
};